var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m578.58 241.64c-132.1-132.1-358.82-38.062-358.82 148.64 0 186.71 226.78 280.74 358.82 148.64 82.078-82.078 82.078-215.21 0-297.28zm101.72 18.281c46.641 89.344 41.719 197.26-12.281 281.9 119.39 119.16 326.21 35.203 326.21-135.32 0.046875-162.89-190.78-249.79-313.92-146.58zm104.11 734.58c-13.969 11.906-31.172 20.25-50.297 23.484-21.141 3.5625-523.74 1.4531-589.97 1.4531-58.875 0-105.38-46.688-105.38-104.67 0-60.984 43.172-134.53 88.734-179.26 44.297-43.453 102.23-77.203 168.47-96.844 39.844 21.562 85.5 33.797 133.97 33.797s94.125-12.234 133.97-33.797c66.234 19.594 124.18 53.344 168.47 96.844 45.891 45 77.016 100.36 87.281 160.92 7.0312 41.438-7.8281 71.156-35.25 98.062zm142.64-355.82c113.3 33.891 213.28 119.06 232.87 235.26 8.7188 51.656-25.359 100.22-76.688 108.89l-204.32 1.3125c46.969-109.5-33-246.05-115.31-317.48 56.859 8.6719 114.23-1.6406 163.45-27.984z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagementIcon);
export default __webpack_public_path__ + "static/media/user-management-icon.72171643d3c48b1eedd111fd1592f33e.svg";
export { ForwardRef as ReactComponent };